module.exports = __webpack_public_path__ + "static/media/boss-tuagom-pic-starting.2e0caf95.png";